// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1MEJu","containerItemsCenter":"Skeleton_containerItemsCenter__3qsOX"};